<template>
	<div>
		<b-card :title="'Color'" header-tag="h5" class="mb-4">
			<hr>
			<b-form>
				<!-- <b-form-row>
					<b-form-group label="Region" class="col-md-12">
						<Multiselect 
							v-if="filterOptions && filterOptions.region"
							class="mt-1"
							:options="filterOptions.region.map(x => x.loc_code)"
							:custom-label="opt => filterOptions.region.find(x => x.loc_code == opt).name"
							v-model="filter.region"
							placeholder="All Regions"
						/>
					</b-form-group>
				</b-form-row> -->
				<!-- <b-form-row>
					<b-form-group label="Search" class="col-md-12 dateCss">
						<input type="text"  v-model="filter.search" class="form-control"/>
					</b-form-group>
				</b-form-row>
				<b-form-row>
					<b-form-group  class="col-md-2 ">
						<button type="button" class="btn btn-primary" @click="loadAPI">Submit</button>
					</b-form-group>
				</b-form-row> -->
			</b-form>
		</b-card>
		<div class="text-right">
			<button class="btn btn-primary" @click="addColor">New Colour</button>
		</div>
		<div class="card mt-2 mb-4">
			
			<table class="table text-center"  v-if="keysTable && dataTable">
				<thead>
					<th v-for="key in keysTable" :key="key">{{prettifyKeys(key)}}</th>
					<th colspan="2"><i class="fa fa-cog"></i></th>
				</thead>
				<tbody>
					<tr v-for="data in dataTable" :key="data.id">
						<td v-for="key in keysTable" :key="key + data.id">{{data[key]}}</td>
						<td><button class="btn btn-outline-primary" @click="editColor(data)"><i class="fa fa-edit"></i></button></td>
						<!-- <td><button class="btn btn-outline-danger" @click="deleteLocation(data.id)"><i class="fa fa-times"></i></button></td> -->
					</tr>
				</tbody>
			</table>
			<div v-else class="text-center pt-4 pb-4">
				<div class="spinner-border" role="status" style="width: 3.5em;height: 3.5em;">
					<span class="sr-only" >Loading...</span>
				</div>
			</div>
		</div>

		<!-- <colorModal 
			v-if="modal.colorModal"
			@closeModal="modal.colorModal = false"
			:data="modal.data"
			:region="filterOptions.region"
			@refreshData="loadAPI"
		/> -->

		<modify-color 
			v-if="modal.colorModal"
			@closeModal="modal.colorModal = false"
			:data="modal.data"
			@refreshData="loadAPI"
		/>

	</div>
</template>

<script>
import vue_universal_table from '../../table/vue_universal_table.vue'
import Multiselect from 'vue-multiselect'
import ModifyColor from './children/modifyColor.vue'

// import colorModal from './childComponents/colorModal.vue'
export default {
  	components: { 
        vue_universal_table, 
        Multiselect,
    ModifyColor , 
        // colorModal 
    },
	data () {
		return {
			dataTable : null,
			keysTable : null,
			filter : {
				region : null,
				search : null
			},
			filterOptions : null,
			modal : {
				colorModal : false,
				data : null
			}
		}
	},
	mounted () {
		this.loadAPI ()
		this.filterOptions = Object.assign({} , this.$store.getters.getFilterOptions)
	},
	methods : {
		addColor () {
			this.modal.data = null
			this.modal.colorModal = true
		},
		editColor (data) {
			this.modal.data = data
			this.modal.colorModal = true
		},
		async loadAPI () {
			let filter = await this.processFilter(this.filter)
			this.$http.get('/api/master/colour' + filter)
			.then((resp) => {
				let data = resp.data.data
				this.keysTable = Object.keys(data[0])


				for(var i = 0 ; i < data.length ; i++) {
					for(var j = 0 ; j < this.keysTable.length ; j++) {
						if(!(this.keysTable[j] == 'is_active' || this.keysTable[j] == 'H1' || this.keysTable[j] == 'H2' || this.keysTable[j] == 'H3'))
							continue;
						
						if(data[i][this.keysTable[j]]) {
							data[i][this.keysTable[j]] = '✔'
						}
						else {
							data[i][this.keysTable[j]] = '✘'
						}
					}
				}

				this.dataTable = data

			})
			.catch((err) => {
				console.log(err)
			})
		},
		async processFilter (filter) {
			let url = '?'
			let keys = Object.keys(filter)

			for(var i = 0 ; i < keys.length ; i++) {
				let key = keys[i]
				if(filter[key])
					url += `${key}=${filter[key]}&`
			}

			return url
		},
		prettifyKeys (key) {
			if(key.includes('_'))
				key = key.split('_').join(' ')
			
			key = key.charAt(0).toUpperCase() + key.slice(1 , key.length)

			return key
		}
	}
	
}
</script>

<style>
  .dateCss input{
    border: 1px solid #e8e8e8;
    border-radius: 5px !important;
    height: 42px;
    margin-top: 3px;
    padding-left: 1% !important;
  }

  .dateCss input::placeholder{
    padding-left: 1%;
  }

</style>
